import { render, staticRenderFns } from "./FooterLandingNew.vue?vue&type=template&id=54e60b7a&scoped=true"
import script from "./FooterLandingNew.vue?vue&type=script&lang=js"
export * from "./FooterLandingNew.vue?vue&type=script&lang=js"
import style0 from "../../../styles/footer-landing-new.scss?vue&type=style&index=0&id=54e60b7a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e60b7a",
  null
  
)

export default component.exports